/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_RetryInputs */

const en_course_retry = /** @type {(inputs: Course_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retry`)
};

const ja_course_retry = /** @type {(inputs: Course_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`再試行`)
};

const fr_course_retry = /** @type {(inputs: Course_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réessayer`)
};

const de_course_retry = /** @type {(inputs: Course_RetryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholen`)
};

/**
* | output |
* | --- |
* | "Retry" |
*
* @param {Course_RetryInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const course_retry = /** @type {((inputs?: Course_RetryInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_RetryInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_course_retry(inputs)
	if (locale === "ja") return ja_course_retry(inputs)
	if (locale === "fr") return fr_course_retry(inputs)
	return de_course_retry(inputs)
});